import { render, staticRenderFns } from "./Intro-main.vue?vue&type=template&id=1c6898ba"
import script from "./Intro-main.vue?vue&type=script&lang=js"
export * from "./Intro-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports